import React, { useState } from 'react';
import {
  Container, Paper, Typography, TextField, Button, Box, CircularProgress,
} from '@mui/material';
import { VpnKey } from '@mui/icons-material';
import { AUTH_LOGOUT_REASON, CHANGE_PASSWORD_MESSAGE, CHANGE_PASSWORD_TEXT } from '../constants/auth';
import { TOAST_SEVERITY } from '../constants/toast';
import { changePassword } from '../services/api';
import { useAuthActions } from '../store/authHooks';
import { useToastActions } from '../store/toastHooks';

const ChangePassword: React.FC = () => {
  const { logout } = useAuthActions();
  const { showToast } = useToastActions();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== confirm) { showToast(CHANGE_PASSWORD_MESSAGE.PASSWORD_MISMATCH, TOAST_SEVERITY.ERROR); return; }
    if (next.length < 6) { showToast(CHANGE_PASSWORD_MESSAGE.PASSWORD_MIN_LENGTH, TOAST_SEVERITY.ERROR); return; }
    setLoading(true);
    try {
      await changePassword(current, next);
      showToast(CHANGE_PASSWORD_MESSAGE.SUCCESS, TOAST_SEVERITY.SUCCESS);
      setTimeout(() => logout(AUTH_LOGOUT_REASON.MANUAL), 2000);
    } catch (err: any) {
      showToast(err?.response?.data?.message || CHANGE_PASSWORD_MESSAGE.FAILED, TOAST_SEVERITY.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <VpnKey color="primary" />
          <Typography variant="h6" fontWeight={700} color="primary.dark">{CHANGE_PASSWORD_TEXT.TITLE}</Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField fullWidth label={CHANGE_PASSWORD_TEXT.CURRENT_PASSWORD_LABEL} type="password" size="small" sx={{ mb: 2 }}
            value={current} onChange={e => setCurrent(e.target.value)} required inputProps={{ 'data-testid': 'cp-current' }} />
          <TextField fullWidth label={CHANGE_PASSWORD_TEXT.NEW_PASSWORD_LABEL} type="password" size="small" sx={{ mb: 2 }}
            value={next} onChange={e => setNext(e.target.value)} required helperText={CHANGE_PASSWORD_TEXT.NEW_PASSWORD_HELPER} inputProps={{ 'data-testid': 'cp-new' }} />
          <TextField fullWidth label={CHANGE_PASSWORD_TEXT.CONFIRM_PASSWORD_LABEL} type="password" size="small" sx={{ mb: 3 }}
            value={confirm} onChange={e => setConfirm(e.target.value)} required inputProps={{ 'data-testid': 'cp-confirm' }} />
          <Button type="submit" variant="contained" disabled={loading} fullWidth>
            {loading ? <CircularProgress size={20} color="inherit" /> : CHANGE_PASSWORD_TEXT.SUBMIT_BUTTON}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ChangePassword;
